import { render, staticRenderFns } from "./headerTab.vue?vue&type=template&id=84f81c56&scoped=true&"
import script from "./headerTab.vue?vue&type=script&lang=js&"
export * from "./headerTab.vue?vue&type=script&lang=js&"
import style0 from "./headerTab.vue?vue&type=style&index=0&id=84f81c56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f81c56",
  null
  
)

export default component.exports